<template>
  <div class="md-content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1>Enhancers v2</h1>

        <md-button href="/shortcuts/v2/enhancer/create">
          Create enhancer
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EnhancersTableV2"
};
</script>
<style scoped>

</style>
